// extracted by mini-css-extract-plugin
export default {"adminLoginForm":"AdminLogin_adminLoginForm__SQTMf"};